var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"759864b5980dcfb3b1d655e31b95801bb8610954"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["where-to-for-lunch@david-0t"]={id:"759864b5980dcfb3b1d655e31b95801bb8610954"};
      